<mat-toolbar color="accent">Select Custom Report</mat-toolbar>

<mat-dialog-content class="bg-slate-50 !text-black">
  <div class="flex flex-col gap-4">
    <pr-information-box>
      <div class="text-primary-500 flex flex-row items-center gap-1">
        <span>This campaign requires a custom report that can identify</span>
        <span class="font-bold">{{ data.campaign.scope }}s.</span>
      </div>
    </pr-information-box>

    <mat-form-field class="bg-white" subscriptSizing="dynamic">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput placeholder="Search" [formControl]="searchCtrl" />
      @if (searchCtrl.value) {
        <button mat-icon-button matSuffix (click)="searchCtrl.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      @for (option of filteredOptions(); track $index) {
        <pr-select-report-template-card
          [template]="option.template"
          [flatButton]="option.customReport ? true : false"
          [selectLabel]="
            option.customReport ? 'Use Existing Report' : 'Create Report'
          "
          (selected)="select(option)"
        />
      } @empty {
        <div class="col-span-full flex flex-col items-center justify-center">
          <pr-empty-state image="list" title="Report Templates" />
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
